import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Settings({ settings, onSave }) {
  const [interest_rate, setInterestRate] = useState(settings.interest_rate || 10);
  const [frequency, setFrequency] = useState(settings.frequency || 'monthly');
  const [usaPropietarios, setUsaPropietarios] = useState(settings.usa_propietarios === true);
  const [emailUser, setEmailUser] = useState('');
  const [emailPass, setEmailPass] = useState('');
  const [emailFromName, setEmailFromName] = useState('');
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [loadingEmail, setLoadingEmail] = useState(true);
  const [saveStatus, setSaveStatus] = useState('');

  useEffect(() => {
    setInterestRate(settings.interest_rate || 10);
    setFrequency(settings.frequency || 'monthly');
    setUsaPropietarios(settings.usa_propietarios === true);
    fetchEmailSettings();
  }, [settings]);

  const fetchEmailSettings = async () => {
    try {
      const res = await axios.get('/api/notification-settings');
      setEmailUser(res.data.email_user || '');
      setEmailPass(res.data.email_pass || '');
      setEmailFromName(res.data.email_from_name || '');
      setNotificationsEnabled(res.data.notifications_enabled !== false);
      setLoadingEmail(false);
    } catch (err) {
      console.error('Error loading email settings:', err);
      setLoadingEmail(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      await axios.post('/api/settings', {
        interest_rate: parseFloat(interest_rate),
        frequency,
        usa_propietarios: usaPropietarios
      });
      setSaveStatus('✅ Configuración guardada');
      setTimeout(() => setSaveStatus(''), 2000);
      onSave();
    } catch (err) {
      setSaveStatus('❌ Error al guardar');
      setTimeout(() => setSaveStatus(''), 2000);
    }
  };

  const handleEmailSave = async (e) => {
    e.preventDefault();

    if (!emailUser || !emailPass) {
      alert('Email y contraseña son requeridos');
      return;
    }

    try {
      await axios.post('/api/notification-settings', {
        email_user: emailUser,
        email_pass: emailPass,
        email_from_name: emailFromName,
        notifications_enabled: notificationsEnabled
      });
      setSaveStatus('✅ Email configurado correctamente');
      setTimeout(() => setSaveStatus(''), 2000);
    } catch (err) {
      setSaveStatus('❌ Error al guardar email');
      setTimeout(() => setSaveStatus(''), 2000);
      alert('Error: ' + err.message);
    }
  };

  return (
    <div className="settings-page">
      <h2>⚙️ Configuración</h2>

      {saveStatus && (
        <div style={{
          padding: '12px',
          marginBottom: '20px',
          borderRadius: '6px',
          background: saveStatus.includes('✅') ? '#d1fae5' : '#fee2e2',
          color: saveStatus.includes('✅') ? '#065f46' : '#991b1b'
        }}>
          {saveStatus}
        </div>
      )}

      {/* Preferencias de Préstamos */}
      <div className="form-card">
        <h3>📊 Preferencias de Préstamos</h3>
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>Porcentaje de Interés Predeterminado (%)</label>
            {/* Campo libre con sugerencias, no un desplegable cerrado. Con una
                lista fija, un interés que no estuviera en ella —un 12%, por
                ejemplo— no encontraba su opción: el navegador mostraba la
                primera (5%) y al guardar lo cambiaba sin avisar. */}
            <input
              type="number"
              step="0.1"
              min="0"
              max="100"
              list="tasas-habituales"
              value={interest_rate}
              onChange={(e) => setInterestRate(e.target.value)}
              required
            />
            <datalist id="tasas-habituales">
              {['5', '10', '15', '20', '25', '30'].map(v => (
                <option key={v} value={v} />
              ))}
            </datalist>
            <small>Este valor se usará por defecto al crear nuevos préstamos</small>
          </div>

          <div className="form-group">
            <label>Frecuencia de Pago Predeterminada</label>
            <select
              value={frequency}
              onChange={(e) => setFrequency(e.target.value)}
            >
              <option value="daily">Diario</option>
              <option value="weekly">Semanal</option>
              <option value="biweekly">Quincenal</option>
              <option value="monthly">Mensual</option>
            </select>
            <small>Esta será la frecuencia por defecto para nuevos préstamos</small>
          </div>

          <div className="form-group">
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
              <input
                type="checkbox"
                checked={usaPropietarios}
                onChange={(e) => setUsaPropietarios(e.target.checked)}
                style={{ width: 'auto', margin: 0 }}
              />
              Repartir los clientes entre varios propietarios
            </label>
            <small>
              Actívalo solo si divides la cartera entre socios o cobradores. Añade
              un campo «Propietario» a cada cliente y te deja filtrar por él.
            </small>
          </div>

          <button type="submit" className="btn-primary">💾 Guardar Preferencias</button>
        </form>
      </div>

      {/* Configuración de Email */}
      <div className="form-card">
        <h3>💌 Configurar Recordatorios por Email</h3>
        <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>
          Configura tu email de Gmail para enviar recordatorios automáticos a tus clientes.
          Los recordatorios se envían diariamente a las 8:00 AM.
        </p>

        {loadingEmail ? (
          <p>Cargando configuración...</p>
        ) : (
          <form onSubmit={handleEmailSave}>
            <div className="form-group">
              <label>📧 Email de Gmail</label>
              <input
                type="email"
                value={emailUser}
                onChange={(e) => setEmailUser(e.target.value)}
                placeholder="tu_email@gmail.com"
                required
              />
              <small>Tu dirección de correo de Gmail</small>
            </div>

            <div className="form-group">
              <label>🔑 Contraseña de Aplicación</label>
              <input
                type="password"
                value={emailPass}
                onChange={(e) => setEmailPass(e.target.value)}
                placeholder="Contraseña de aplicación (16 caracteres)"
                required
              />
              <small>
                📌 <strong>Cómo obtenerla:</strong> Ve a{' '}
                <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noopener noreferrer">
                  Google App Passwords
                </a>
                {' '}y genera una contraseña para "Correo" en Windows/Linux
              </small>
            </div>

            <div className="form-group">
              <label>Nombre de Remitente (Opcional)</label>
              <input
                type="text"
                value={emailFromName}
                onChange={(e) => setEmailFromName(e.target.value)}
                placeholder="Ej: Mi Empresa"
              />
              <small>Nombre que verán tus clientes al recibir el email</small>
            </div>

            <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                id="notificationsEnabled"
                checked={notificationsEnabled}
                onChange={(e) => setNotificationsEnabled(e.target.checked)}
              />
              <label htmlFor="notificationsEnabled" style={{ margin: 0 }}>
                ✅ Habilitar recordatorios automáticos
              </label>
            </div>

            <button type="submit" className="btn-primary">💾 Guardar Email</button>
          </form>
        )}

        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: '#f0fdf4',
          borderRadius: '6px',
          borderLeft: '4px solid #10b981'
        }}>
          <p style={{ margin: '0 0 10px 0', fontWeight: 'bold', color: '#065f46' }}>
            ✅ ¿Qué sucede cuando configures?
          </p>
          <ul style={{ margin: 0, paddingLeft: '20px', color: '#065f46', fontSize: '14px' }}>
            <li>📧 Recordatorios automáticos cada día a las 8:00 AM</li>
            <li>🔴 Alerta cuando un préstamo esté vencido</li>
            <li>🟡 Aviso cuando falten 3, 7 y 1 días para vencer</li>
            <li>📱 Se envía a ti Y a tu cliente</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Settings;
